import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import Layout from './components/Layout';
import LandingPage from './pages/LandingPage';
import HomePage from './pages/HomePage';
import CategoriesPage from './pages/CategoriesPage';
import CategoryDetailPage from './pages/CategoryDetailPage';
import DocumentExplorer from './pages/DocumentExplorer';
import SearchPage from './pages/SearchPage';
import ArticlePage from './pages/ArticlePage';
import FavoritesPage from './pages/FavoritesPage';
import ChatAssistant from './pages/ChatAssistant';
import AboutPage from './pages/AboutPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import { configureNativeStatusBar } from './lib/nativeStatusBar';
import { initNativePushListeners } from './lib/pushNotifications';
import RateAppModal from './components/RateAppModal';
import { useStatusBarTheme } from './lib/useStatusBarTheme';
import { ThemeProvider, useTheme } from './lib/ThemeContext';
import UpdateBanner from './components/UpdateBanner';
import DisclaimerModal from './components/DisclaimerModal';
// Auth pages temporarily disabled — code preserved for future re-enable.
// import AuthPage from './pages/AuthPage';
// import AuthCallback from './pages/AuthCallback';
// import OnboardingPage from './pages/OnboardingPage';
// import ProfilePage from './pages/ProfilePage';
import './App.css';

function AppShell() {
  useEffect(() => {
    configureNativeStatusBar();
    initNativePushListeners();
  }, []);

  const { theme } = useTheme();
  // Status bar follows the active theme :
  //  - light → white shell + dark system icons
  //  - dark  → very-dark-blue shell (#0B1220) + white system icons
  useStatusBarTheme(theme);

  return (
    <AuthProvider>
      <BrowserRouter>
        <UpdateBanner />
        <DisclaimerModal />
        <RateAppModal />
        <Routes>
          {/* Direct entry to home — auth disabled for now */}
          <Route path="/" element={<Navigate to="/accueil" replace />} />
          <Route path="/auth" element={<Navigate to="/accueil" replace />} />
          <Route path="/auth/callback" element={<Navigate to="/accueil" replace />} />
          <Route path="/onboarding" element={<Navigate to="/accueil" replace />} />
          <Route path="/profil" element={<Navigate to="/accueil" replace />} />
          <Route path="/landing" element={<LandingPage />} />

          <Route element={<Layout />}>
            <Route path="/accueil" element={<HomePage />} />
            <Route path="/categories" element={<CategoriesPage />} />
            <Route path="/categorie/:categoryId" element={<CategoryDetailPage />} />
            <Route path="/explorer/:domain" element={<DocumentExplorer />} />
            <Route path="/article/:articleId" element={<ArticlePage />} />
            <Route path="/recherche" element={<SearchPage />} />
            <Route path="/a-propos" element={<AboutPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/favoris" element={<FavoritesPage />} />
            <Route path="/assistant" element={<ChatAssistant />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AppShell />
    </ThemeProvider>
  );
}

export default App;
